module.exports = __webpack_public_path__ + "media/luxury-2026/garden-pavilion-960-9b54db8f.jpg";